import type { Order, Payment } from "@graphql/generated/components";
import { paymentMethodMap } from "@lib/constants/payment";
import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";

export function getSuccessPayment(order: Order): Payment | null {
    return (
        order?.paymentInfo?.payments
            .filter(
                (payment) =>
                    payment.paymentMethodInfo?.method === "AMAZON_PAY" &&
                    payment?.transactions?.some(
                        (transaction) =>
                            transaction?.type === "Authorization" &&
                            transaction?.state === "Success"
                    )
            )
            .find((payment) => payment) || null
    );
}

export function getReadablePaymentMethod(paymentMethod: string): string {
    if (!paymentMethod) {
        return "";
    }

    const lowerCasePaymentMethod = paymentMethod.toLowerCase();
    for (const key of Object.keys(paymentMethodMap)) {
        if (lowerCasePaymentMethod.includes(key)) {
            return paymentMethodMap[key];
        }
    }

    return "";
}

export function logError(message: string, id: string): void {
    Logger.info(ServiceType.AMAZON_PAY, `PAYMENT: ${message} for cartId: ${id}`, {
        tag: LogTag.PAYMENT,
        cartId: id,
    });
}
